import get from 'lodash/get';
import { TRANSLATIONS } from '../actions/constantsActions';

const initialState = {};

export default function translations(state = initialState, action) {
  if (action.type === TRANSLATIONS) {
    return action.translations || state;
  }
  return state;
}

export const getTranslations = state => get(state, 'translations');
